import {axios} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  deleteById({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.get(`dataShare/deleteById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  save({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`dataShare/save`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findDataShare({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`dataShare/findDataShare`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
